import { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute, DomainRedirect } from '../../../utils/domain/routingComponents'
import { enterpriseStatusPageRetailerAccessControl } from '../access-control/enterpriseStatusPageRetailerAccess.configuration'

const RetailerEnterpriseStatusPage = lazy(() => import('../pages/RetailerEnterpriseStatusPage'))

const RetailerIncidentDetailPage = lazy(() => import('../pages/RetailerIncidentDetailPage'))

export const enterpriseStatusPageScopedRouter = (
  <DomainRoute
    route="enterprise-status-page"
    accessControl={enterpriseStatusPageRetailerAccessControl}
  >
    <DashSwitch>
      <DomainRoute
        exact
        route="enterprise-status-page-incident-details"
        component={RetailerIncidentDetailPage}
      />
      <DomainRoute exact route="enterprise-status-page" component={RetailerEnterpriseStatusPage} />
      <DomainRedirect toRoute="enterprise-status-page" />
    </DashSwitch>
  </DomainRoute>
)
